export default __webpack_public_path__ + "static/media/plus-circle.72cc5ea4.svg";